module.exports = __webpack_public_path__ + "static/img/2s-design-b1.9275921.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/2s-design-b1.jpg
// module id = b64E
// module chunks = 0